module.exports = __webpack_public_path__ + "static/media/notification.ee5e6562.svg";